import { message } from "antd";
import axiosInstance from "../../../helpers/axios";
import { responseDataFormate } from "../../../helpers/bycrypt";
import { API_URL } from "../../../helpers/utils";

interface CreateSubAdminParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const createSubAdminAPI =
  ({ payload, onSuccess, onError }: CreateSubAdminParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.post(
        `${API_URL}/admin/sub-admin`,
        payload,
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message || "Sub Admin created successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to create sub admin");
        onError?.();
      }
    } catch (error: any) {
      console.error("Create sub admin error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message || "Unable to create sub admin";
      message.error(errorMessage);
    }
  };

export interface SubAdminFilterParams {
  page?: number;
  limit?: number;
  search?: string;
  id?: string;
  sortBy?: string | null;
  sortOrder?: string | null;
}

interface GetListParams {
  filters: SubAdminFilterParams;
  onSuccess?: (data: any) => void;
  onError?: () => void;
  signal?: AbortSignal;
}

export const getSubAdminListAPI =
  ({ filters, onSuccess, onError, signal }: GetListParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get("/admin/sub-admin", {
        params: filters,
        signal,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to fetch Sub-Admins");
        onError?.();
      }
    } catch (error: any) {
      if (error.code === "ERR_CANCELED" || error.name === "AbortError") return;
      console.error("Get Sub-Admin List Error:", error);
      message.error(error?.response?.data?.message || "Unable to fetch data");
      onError?.();
    }
  };

interface UpdateSubAdminParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const updateSubAdminAPI =
  ({ payload, onSuccess, onError }: UpdateSubAdminParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put(
        `${API_URL}/admin/sub-admin`,
        payload,
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message || "Sub Admin updated successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to update sub admin");
        onError?.();
      }
    } catch (error: any) {
      console.error("Update sub admin error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message || "Unable to update sub admin";
      message.error(errorMessage);
    }
  };

interface DeleteSubAdminParams {
  id: string;
  onSuccess: () => void;
  onError: () => void;
}

export const deleteSubAdminAPI =
  ({ id, onSuccess, onError }: DeleteSubAdminParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.delete(
        `${API_URL}/admin/sub-admin`,
        {
          data: { id: id },
        },
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message || "Sub Admin deleted successfully");
        onSuccess?.();
      } else {
        message.error(result?.message || "Failed to delete Sub Admin");
        onError?.();
      }
    } catch (error: any) {
      console.error("Delete Sub Admin error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message || "Unable to delete Sub Admin";
      message.error(errorMessage);
    }
  };
